<template>
  <div class="not_found">
    <div class="content_box content_auto">
      <div class="img_box">
        <img class="full_img" src="./../../assets/images/404.png" alt="" />
      </div>
      <p class="tips">{{ $t('您找的页面已丢失！') }}</p>
      <div class="btn_box">
        <Button type="primary" @click="jumpTo()">{{ $t('返回首页') }}</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {
    jumpTo() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style lang="less" scoped>
.not_found {
  height: calc(100vh - 60px);
  background: rgba(19, 22, 37, 1);
  .content_box {
    overflow: hidden;
    .img_box {
      margin: 100px auto 0;
      width: 400px;
      height: 300px;
    }
    .tips {
      margin-top: 10px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, 'PingFang SC';
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      text-align: center;
    }
    /deep/ .btn_box {
      margin-top: 30px;
      text-align: center;
      .iview_button_mixin();
    }
  }
}
</style>
